import { useEffect, useState } from "react";
import { useParams, useOutletContext } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import * as Icons from "lucide-react";
import { Store, Coins, Package } from "lucide-react";

export default function PlayerShop() {
  const { id } = useParams();
  const { user, refreshUser } = useOutletContext();
  const [shop, setShop] = useState(null);

  const load = async () => { const { data } = await api.get(`/shops/${id}`); setShop(data); };
  useEffect(() => { load(); }, [id]);

  const buy = async (l) => {
    try { await api.post(`/stalls/${l.listing_id}/buy`); toast.success(`Bought ${l.item.name} for ${l.price} Bits!`); refreshUser?.(); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Purchase failed"); }
  };

  if (!shop) return null;
  return (
    <div data-testid="player-shop-page" className="max-w-3xl mx-auto">
      <span className="label-cap text-primary flex items-center gap-2"><Store className="w-4 h-4" /> User Scrap-Shop</span>
      <h1 className="font-head font-black text-3xl sm:text-4xl mt-2 mb-1">{shop.seller_name}'s Shop</h1>
      <p className="text-muted-foreground mb-5">{shop.mine ? "This is your storefront. Prices are set in Bits." : `Browse ${shop.seller_name}'s wares — fixed prices in Bits.`}</p>

      <div className="panel-glow p-4">
        {shop.listings.length === 0 ? <p className="text-sm text-muted-foreground p-8 text-center">This shop is empty right now.</p> : (
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            {shop.listings.map((l) => {
              const Icon = Icons[l.item.icon?.replace(/(^|-)([a-z])/g, (_, s, c) => c.toUpperCase())] || Package;
              return (
                <div key={l.listing_id} data-testid={`shop-listing-${l.listing_id}`} className="panel p-3 flex flex-col items-center gap-2">
                  <Icon className="w-9 h-9 text-primary" />
                  <div className="text-center"><div className="font-bold text-sm leading-tight">{l.item.name}</div><div className="label-cap text-[9px]">{l.item.rarity}</div></div>
                  <div className="mono text-secondary font-bold text-sm"><Coins className="w-3.5 h-3.5 inline mr-1" />{l.price}</div>
                  {shop.mine ? <span className="label-cap text-[9px]">listed</span> :
                    <button data-testid={`shop-buy-${l.listing_id}`} onClick={() => buy(l)} className="btn-primary w-full justify-center text-xs py-1.5">Buy</button>}
                </div>
              );
            })}
          </div>
        )}
      </div>
      {shop.mine && <p className="text-xs text-muted-foreground mt-3">Tip: list more items from the Market → My Stall.</p>}
    </div>
  );
}
